import React from 'react';
import styles from './Timer.module.scss';
import { useStoreState } from 'pullstate';
import { getTimeLeft } from '../../../store/DesallSelectors';
import DesallStore from '../../../store/DesallStore';

const TimerWLF: React.FC = () => {
  const timeLeft = useStoreState(DesallStore, getTimeLeft);

  return (
    <div className={`${styles.mainCountDown} col-3 flex-shrink-1 bg-light-gray-3  color-light fw-bold d-flex align-items-center text-center justify-content-center`}>
      <div className="px-3">
        <div className="text-xl fw-bold">{String(timeLeft.days).padStart(2, '0')}</div>
        <div>days</div>
      </div>
      <div className="d-none d-lg-flex px-3 px-md-0 px-lg-3 ps-5">
        <div className="px-2">
          <div className="text-xl fw-bold">{String(timeLeft.hours).padStart(2, '0')}</div>
          <div>hrs</div>
        </div>
        <div className="separator">:</div>
        <div className="px-2">
          <div className="text-xl fw-bold">{String(timeLeft.minutes).padStart(2, '0')}</div>
          <div>min</div>
        </div>
        <div className="separator">:</div>
        <div className="px-2">
          <div className="text-xl fw-bold">{String(timeLeft.seconds).padStart(2, '0')}</div>
          <div>sec</div>
        </div>
      </div>
    </div>
  );
};

export default TimerWLF;
